import { render, staticRenderFns } from "./CustomDatepicker-vue2.vue?vue&type=template&id=6c0125c0"
import script from "./CustomDatepicker-vue2.vue?vue&type=script&lang=js"
export * from "./CustomDatepicker-vue2.vue?vue&type=script&lang=js"
import style0 from "./CustomDatepicker-vue2.vue?vue&type=style&index=0&id=6c0125c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports